import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
  getTTPUser,
  getClientCredential,
  getSelectedOrganization,
  updateGoPeopleSelectedOrganization,
  getGoPeopleOrganizationsCommunity,
  getGoPeopleUserProfile,
  autoLoginWithTtpToken,
  getUsersSettings
} from "../api";
import {
  getAuthInfosFromCookie,
  authHasExpired,
  getCookie,
  logout,
  createAuthCookie,
  createCommunityCookie,
  getCommunityFromCookie,
  transformGoApiUser,
  updateAuthCookieGoPeopleOrganizationId,
  setCookie
} from "../utils";
import { APP_ENV } from "../config";
import { setLanguage, fetchFiduciary, setFolderFetched } from "./index";
import { isJWTValid, extractAuthContextFromJWT } from "../lib/jwt";

const initialState = {
  fetching: false,
  fetched: false,
  token: "",
  jwtToken: "",
  refreshToken: "",
  goPeopleUserId: "",
  goPeopleCommunityId: "",
  goPeopleOrganizationId: "",
  clientToken: "",
  expiresIn: null,
  createdAt: null,
  user: null,
  error: null,
  loggedAs: "GUEST",
  loggedAsPost: null,
  loggedIsAdmin: false,
  navCommunity: null,
  scope: "",
  communitySwitchRequested: false,
  communityOld: null,
  autoLoging: false
};
export const updateSelectedOrganization = createAsyncThunk(
  "auth/updateSelectedOrganization",
  async (
    { uuid, community, savedJwt, goPeopleUserId },
    { getState, dispatch }
  ) => {
    const { jwtToken, user, token } = getState().auth;
    const { id: userId } = user;
    // const { id: organizationId, uuid } = organization;

    try {
      const response = await updateGoPeopleSelectedOrganization(
        community,
        uuid
      );

      if (
        response &&
        response.selectedorganization &&
        response.selectedorganization.uuid
      ) {
        await dispatch(fetchFiduciary(response.selectedorganization.uuid));
      }

      return {
        communityUuid: community,
        organizationUuid: response?.selectedorganization?.uuid ?? null,
        organizationApiId:
          response?.selectedorganization?.ttp_organization_id ?? null,
      };
      return response;
    } catch (error) {
      console.error(
        "Error updating selected organization: navCommunity====== ",
        error
      );
      throw error;
    }
  }
);
export const fetchNavCommunity = createAsyncThunk(
  "auth/fetchNavCommunity",
  async (tmp, { getState, dispatch }) => {
    const { token, navCommunity, user } = getState().auth;
    if (!token || !user) {
      return false;
    }

    return getSelectedOrganization(token).then((resp) => {
      const help = typeof resp === "string" ? JSON.parse(resp) : { ...resp };
      if (
        help &&
        help.data &&
        help.data.organization &&
        (!navCommunity || navCommunity.id !== help.data.organization.id)
      ) {
        const { organization } = help.data;
        const chosed = user.communities.filter(
          (com) => organization.id === com.id
        );

        if (!chosed || chosed.length === 0) {
          dispatch(setAuthLoggedAs("CLIENT"));
        }

        dispatch(
          setNavCommunity(
            user && user.communities && chosed && chosed.length > 0
              ? chosed[0]
              : organization
          )
        );
      }
    });
  }
);

export const fetchAutoAuthUser = createAsyncThunk(
  "auth/fetchAutoAuthUser",
  async ({ user, fiduciaryId }, { getState, dispatch }) => {
    const state = getState();

    const response = await getTTPUser({
      userId: user.id,
      token: user.token,
    });

    let result = response.data[0];
    if (fiduciaryId) {
      result.fiduciaryId = fiduciaryId;
    }
    return result;
  }
);

export const handleAuthSuccess = createAsyncThunk(
  "auth/handleAuthSuccess",
  async (data, { dispatch }) => {
    if (!data.accessToken) throw new Error("No JWT token");
    if (!isJWTValid(data.accessToken)) throw new Error("Invalid JWT");

    const authC = extractAuthContextFromJWT(data.accessToken);

    const dtExpire = new Date();
    dtExpire.setTime(dtExpire.getTime() + authC.expiresAt * 1000);

    const authData = {
      jwtToken: data.accessToken,
      refreshToken: data.refreshToken,
      token: authC.ttpAccessToken,
      expiresIn: authC.expiresAt,
      createdAt: Math.floor(Date.now() / 1000),
      scope: authC.scope,
      communityUuid: data.communityId,
      goPeopleOrganizationId: data.fiduciaryId
    };

    setCookie(`ttp_auth_${APP_ENV}`, JSON.stringify(authData), dtExpire, "/");

    const userResponse = await getGoPeopleUserProfile(data.accessToken);

    let organizationsResponse;
    try {
      organizationsResponse = await getGoPeopleOrganizationsCommunity();
    } catch (e) {
      organizationsResponse = null;
    }

    // dispatch(setAuthToken(authC.ttpAccessToken));
    // dispatch(setJwtToken(data.accessToken));
    // dispatch(setRefreshToken(data.refreshToken));
    // dispatch(setExpiresIn(authC.expiresAt));
    // dispatch(setTokenCreatedAt(authC.createdAt));
    // dispatch(setAuthScope(authC.scope));
    // dispatch(
    //   setAuthGoPeopleCommunityId(
    //     userResponse.data.data[0].user.selected_community_id
    //   )
    // );
    // dispatch(setAuthGoPeopleUserId(userResponse.data.data[0].user.uuid));

    const dataRoot = userResponse.data.data[0];

    let selectedCommunity =
      dataRoot.communities.find(
        (c) => c.uuid === dataRoot.user.selected_community_id
      ) || dataRoot.communities[0];
    let ttpAccessToken = authC.ttpAccessToken;


    let userSettings = null;

    try {
      userSettings = await getUsersSettings({
        token: ttpAccessToken,
        language: "",
        word: "",
        organizationId: selectedCommunity?.ttp_community_id,
      });
    } catch (e) {
      console.warn("getUsersSettings failed, continue without it", e);
    }
    const userData = userResponse.data.data[0];

    setAuthUser(userData.user);
    const userBlogRole = userSettings?.data.data?.find(
      (u) => u.id === userResponse.data.data[0].user.ttp_user_id
    );

    let fiduciary = selectedCommunity ?? {};
    fiduciary["id"] = selectedCommunity?.ttp_community_id;

    let transformGoApiUserData = transformGoApiUser(
      userResponse.data.data[0],
      selectedCommunity,
      organizationsResponse?.data?.data,
      userBlogRole
    );
    let dataOrganisation = transformGoApiUserData;
    let token = {
      access_token: authC.ttpAccessToken,
      createdAt: 1762535302,
      expires_in: authC.ttpExpiresIn,
      scope: authC.ttpScope,
      token_type: "bearer",
    };
    dispatch(
      setAuthTokenUser({
        token: token,
        data: dataOrganisation,
      })
    );
    dispatch(
      setNavCommunity(
        dataOrganisation && dataOrganisation.navCommunity
          ? dataOrganisation.navCommunity
          : null
      )
    );

    const authData1 = {
      jwtToken: data.accessToken,
      refreshToken: data.refreshToken,
      expiresIn: authC.expiresAt,
      createdAt: data.createdAt,
      scope: data.scope,
      userGoApiId: dataRoot.user.uuid,
      communityGoApiId: selectedCommunity?.uuid,
      communityApiId: selectedCommunity?.ttp_community_id,
    };

    updateAuthCookieGoPeopleOrganizationId(
      data.accessToken,
      dataOrganisation.navCommunity.uuid,
      selectedCommunity?.uuid,
      selectedCommunity?.ttp_community_id,
      false,
      dataRoot.user.ttp_user_id
    );
    dispatch(setFolderFetched(false));
    await dispatch(fetchFiduciary());

    return {
      jwtToken: data.accessToken,
      refreshToken: data.refreshToken,
      authC,
      user: dataRoot.user,
      transform: transformGoApiUserData,
      selectedCommunity,
    };
  }
);

export const fetchAuthUser = createAsyncThunk(
  "auth/fetchAuthUser",
  async (user, { getState, dispatch }) => {
    const state = getState();
    const { token, jwtToken } = getState().auth;
    let authInfos = getAuthInfosFromCookie();

    const jwtToken1 = authInfos?.jwtToken || authInfos?.jwt || user?.jwtToken || user?.jwt || jwtToken;
    
    if (jwtToken1) {

      const userResponse = await getGoPeopleUserProfile(jwtToken1);
      const organizationsResponse = await getGoPeopleOrganizationsCommunity();
      const dataRoot = userResponse?.data?.data?.[0];

      const selectedCommunity = dataRoot?.communities?.find(
        (c) => c.uuid === dataRoot?.user?.selected_community_id
      );

      let userBlogRole = null;

      const userSettings = await getUsersSettings({
        token,
        language: "",
        word: "",
        organizationId: selectedCommunity?.ttp_community_id
      });
      if (userSettings?.data?.data?.length > 0) {
        userBlogRole = userSettings.data.data.find(
          (u) => u.id === userResponse.data.data[0].user.ttp_user_id
        );
      }

      const userGoApi = transformGoApiUser(
        userResponse.data.data[0],
        selectedCommunity,
        organizationsResponse?.data?.data,
        userBlogRole
      );
      // if (userResponse && userResponse.data && userResponse.data.data && userResponse.data.data[0]) {
      //   const organisationUuid = userResponse.data.data[0].selected_community.selected_organization ? userResponse.data.data[0].selected_community.selected_organization.uuid : null;
      //   const comunityUuid = userResponse.data.data[0].selected_community.uuid;
      //   // dispatch(setAuthGoPeopleOrganizationId(organisationUuid))
      //   if (comunityUuid && organisationUuid)
      //     updateAuthCookieGoPeopleOrganizationId(comunityUuid, organisationUuid);
      // }
      return userGoApi?.user;
    } else {
      const response = await getTTPUser({
        userId: user.id,
        token: state.auth.token,
      });
      return response.data[0];
    }
  }
);

export const autoLoginWithTtp = createAsyncThunk(
  "auth/autoLoginWithTtp",
  async (authInfos, { dispatch }) => {
    try {
      if (!authInfos?.token) return null;
      
      const data = await autoLoginWithTtpToken(authInfos.token);
      if (!data?.jwtToken) return null;

      const jwtToken = data.jwtToken;



      const updatedAuth = {
        ...authInfos,
        jwtToken,
        createdAt: Math.floor(Date.now() / 1000),
      };
      const authData = {
        userApiId: updatedAuth.id,
        token: updatedAuth.token,
        jwtToken: jwtToken,
        jwt: jwtToken,
        expiresIn: authInfos.expiresIn,
        createdAt: authInfos.createdAt
      };

      let dtExpire = new Date();
      dtExpire.setTime(dtExpire.getTime() + authInfos.expiresIn * 1000);

      setCookie(
        `ttp_auth_${APP_ENV}`,
        JSON.stringify(authData),
        dtExpire,
        "/",
        "unitedassociates.be"
      );
      setCookie(`ttp_auth_${APP_ENV}`, JSON.stringify(authData), dtExpire, "/");

      dispatch(setJwtToken(jwtToken));

      await dispatch(fetchAuthUser(updatedAuth)).unwrap();

      return updatedAuth;
    } catch (error) {
      console.error("Auto login with TTP failed:", error);
      throw error;
    }
  }
);



export const fetchClientToken = createAsyncThunk(
  "auth/fetchClientToken",
  async (user, { getState, dispatch }) => {
    const response = await getClientCredential();
    const helpResp =
      typeof response === "string" ? JSON.parse(response) : response;
    return helpResp.token.access_token;
  }
);

export const login = createAsyncThunk(
  "auth/login",
  async (user, { getState, dispatch }) => {
    const state = getState();
    let authInfos = getAuthInfosFromCookie();
    if (!authInfos || authHasExpired(authInfos)) {
      logout();
    }

    const cookieLang = getCookie(`ttp_lang_${APP_ENV}`);
    if (cookieLang) {
      dispatch(setLanguage(cookieLang));
    } else {
      const lng = localStorage.getItem("lng") || "fr";
      dispatch(setLanguage(lng));
    }

    if (authInfos) {
      dispatch(setAuthToken(authInfos.token));
      // dispatch(fetchAuthUser(authInfos));
      dispatch(setExpiresIn(authInfos.expiresIn));
      dispatch(setTokenCreatedAt(authInfos.createdAt));
      dispatch(setAuthScope(authInfos.scope));
      // dispatch(fetchFiduciary());
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthTokenUser: (state, { payload }) => {
      createAuthCookie({
        token: payload.token,
        user: payload.data.user,
      });
      state.token = payload.token.access_token;
      state.expiresIn = payload.token.expiresIn;
      state.createdAt = payload.token.createdAt;
      state.user = payload.data.user;
      state.user.role = payload.data.role;
      state.scope = payload.token.scope;

      if (payload.data.organization && payload.data.organization.length > 0) {
        state.user.communities = [payload.data.organization];
        state.navCommunity = payload.data.organization;
      }

      state.loggedAs = "COLLABORATOR";
      state.loggedIsAdmin = true;
      payload.data.role && payload.data.role.typeStatus === "FOLDER"
        ? "CLIENT"
        : "COLLABORATOR";
      state.loggedAsPost =
        payload.data.role && payload.data.role.type
          ? payload.data.role.type
          : null;
      if (payload.data.role) {
        if (
          ["LEGAL_REPRESENTATIVE", "MANAGER"].includes(
            payload.data.role.type
          ) &&
          payload.data.role.typeStatus !== "FOLDER"
        ) {
          state.loggedIsAdmin = true;
        }
      }
    },
    setAuthJwtTokenUser: (state, { payload }) => {
      createAuthCookie({
        jwtToken: payload.jwtToken,
        user: payload.data.user,
      });
      state.token = payload.token.access_token;
      state.expiresIn = payload.token.expiresIn;
      state.createdAt = payload.token.createdAt;
      state.user = payload.data.user;
      state.user.role = payload.data.role;
      state.scope = payload.token.scope;

      if (payload.data.organization && payload.data.organization.length > 0) {
        state.user.communities = [payload.data.organization];
        state.navCommunity = payload.data.organization;
      }

      state.loggedAs = "COLLABORATOR";
      state.loggedIsAdmin = true;
      payload.data.role && payload.data.role.typeStatus === "FOLDER"
        ? "CLIENT"
        : "COLLABORATOR";
      state.loggedAsPost =
        payload.data.role && payload.data.role.type
          ? payload.data.role.type
          : null;
      if (payload.data.role) {
        if (
          ["LEGAL_REPRESENTATIVE", "MANAGER"].includes(
            payload.data.role.type
          ) &&
          payload.data.role.typeStatus !== "FOLDER"
        ) {
          state.loggedIsAdmin = true;
        }
      }
    },
    setAuth: (state, { payload }) => {
      state = { ...state, payload };
    },
    setAuthUser: (state, action) => {
      state.user = action.payload;
    },
    setJwtToken: (state, action) => {
      state.jwtToken = action.payload;
    },
    setAuthGoPeopleUserId: (state, action) => {
      state.goPeopleUserId = action.payload;
    },
    setAuthGoPeopleCommunityId: (state, action) => {
      state.goPeopleCommunityId = action.payload;
    },
    setAuthGoPeopleOrganizationId: (state, action) => {
      state.goPeopleOrganizationId = action.payload;
    },
    setAuthLoggedAs: (state, action) => {
      state.loggedAs = action.payload;
    },
    setAuthLoggedAsPost: (state, action) => {
      state.loggedAsPost = action.payload;
    },
    setAuthLoggedIsAdmin: (state, action) => {
      state.loggedIsAdmin = action.payload;
    },
    setExpiresIn: (state, action) => {
      state.expiresIn = action.payload;
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
    },
    setTokenCreatedAt: (state, action) => {
      state.createdAt = action.payload;
    },
    setAuthToken: (state, action) => {
      state.token = action.payload;
    },
    setClientToken: (state, action) => {
      state.clientToken = action.payload;
    },
    setNavCommunity: (state, action) => {
      createCommunityCookie(action.payload);
      state.navCommunity = action.payload;
      // state.communitySwitchRequested2 = true;
      // window.location.href = "/";
    },
    setCommunitySwitchRequested: (state, action) => {
      state.communitySwitchRequested = action.payload;
    },
    setCommunityOld: (state, action) => {
      state.communityOld = action.payload;
    },
    setAutoLoging: (state, action) => {
      state.autoLoging = action.payload;
    },
    unsetNavCommunity: (state, action) => {
      state.navCommunity = null;
    },
    setAuthFetched: (state, { payload }) => {
      state.fetched = payload;
    },
    setAuthScope: (state, action) => {
      state.scope = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchClientToken.fulfilled, (state, action) => {
      state.clientToken = action.payload;
    });
    builder.addCase(fetchAuthUser.fulfilled, (state, { payload }) => {
      state.user = payload;

      let communityAdded = false;

      if (payload.uaRoles && payload.uaRoles.length > 0) {
        const community = getCommunityFromCookie();
        const authInfos = getAuthInfosFromCookie();
        if (community || (authInfos && authInfos.communityApiId)) {
          const id = community ? community.id : authInfos.communityApiId;
          const role = payload.uaRoles.filter((r) => r.organization.id === id);
          if (role.length > 0) {
            state.user.role = role[0];
            state.navCommunity = role[0].organization;
            communityAdded = true;
          }
        } else {
          let role = null;
          payload.uaRoles.forEach((item) => {
            if (!role || role?.organization?.uaStatus !== "VALIDATED") {
              if (!role) {
                role = item;
              } else {
                if (item.organization.uaStatus === "VALIDATED") {
                  role = item;
                } else if (
                  item.organization.uaStatus === "PENDING" &&
                  role.organization.uaStatus === "CREATED"
                ) {
                  role = item;
                }
              }
            }
          });

          state.user.role = role;
          state.navCommunity = role.organization;
          communityAdded = true;
        }
      }
      // if (!communityAdded) {
      //   if (payload.communities && payload.communities.length > 0) {
      //     if (
      //       payload.role &&
      //       payload.role.organization.id === payload.communities[0].id &&
      //       payload.role.organization.owner
      //     ) {
      //       state.navCommunity = payload.role.organization.owner;
      //     } else {
      //       if (payload.communities.length === 1) {
      //         state.navCommunity = payload.communities[0];
      //       } else {
      //         const community = payload.communities.filter(
      //           (c) => c.officeType === "ITAA"
      //         );
      //         if (community && community.length > 0) {
      //           state.navCommunity = community[0];
      //         } else {
      //           state.navCommunity = payload.communities[0];
      //         }
      //       }
      //     }
      //   }
      // }
      state.loggedAs =
        payload.role && payload.role.typeStatus === "FOLDER"
          ? "CLIENT"
          : "COLLABORATOR";
      state.loggedAsPost =
        payload.role && payload.role.type ? payload.role.type : null;
      if (payload.role) {
        if (
          ["LEGAL_REPRESENTATIVE", "MANAGER"].includes(payload.role.type) &&
          payload.role.typeStatus !== "FOLDER"
        ) {
          state.loggedIsAdmin = true;
        }
      }
      state.fetched = true;
    });
    builder.addCase(fetchAuthUser.rejected, (state, action) => {
      state.fetched = true;
    });
    builder.addCase(fetchAutoAuthUser.fulfilled, (state, { payload }) => {
      createAuthCookie({
        token: {
          access_token: state.token,
          createdAt: state.createdAt,
          expires_in: state.expiresIn,
          scope: state.scope,
        },
        user: payload,
      });
      state.user = payload;

      if (payload.uaRoles && payload.uaRoles.length > 0) {
        if (payload.fiduciaryId) {
          const role = payload.uaRoles.filter(
            (r) => r.organization.id === payload.fiduciaryId
          );
          if (role.length > 0) {
            state.user.role = role[0];
            createCommunityCookie(role[0].organization);
            state.navCommunity = role[0].organization;
          }
        } else {
          let role = null;
          payload.uaRoles.forEach((item) => {
            if (!role || role?.organization?.uaStatus !== "VALIDATED") {
              if (!role) {
                role = item;
              } else {
                if (item.organization.uaStatus === "VALIDATED") {
                  role = item;
                } else if (
                  item.organization.uaStatus === "PENDING" &&
                  role.organization.uaStatus === "CREATED"
                ) {
                  role = item;
                }
              }
            }
          });

          state.user.role = role;
          state.navCommunity = role.organization;
        }
      }

      // if (payload.communities && payload.communities.length > 0) {
      //   if (payload.fiduciaryId) {
      //     state.navCommunity = payload.communities.filter(
      //       (i) => i.id === payload.fiduciaryId
      //     );
      //   } else {
      //     if (
      //       payload.role &&
      //       payload.role.organization.id === payload.communities[0].id &&
      //       payload.role.organization.owner
      //     ) {
      //       state.navCommunity = payload.role.organization.owner;
      //     } else {
      //       if (payload.communities.length === 1) {
      //         state.navCommunity = payload.communities[0];
      //       } else {
      //         const community = payload.communities.filter(
      //           (c) => c.officeType === "ITAA"
      //         );
      //         if (community && community.length > 0) {
      //           state.navCommunity = community[0];
      //         } else {
      //           state.navCommunity = payload.communities[0];
      //         }
      //       }
      //     }
      //   }
      // }
      state.loggedAs =
        payload.role && payload.role.typeStatus === "FOLDER"
          ? "CLIENT"
          : "COLLABORATOR";
      state.loggedAsPost =
        payload.role && payload.role.type ? payload.role.type : null;
      if (payload.role) {
        if (
          ["LEGAL_REPRESENTATIVE", "MANAGER"].includes(payload.role.type) &&
          payload.role.typeStatus !== "FOLDER"
        ) {
          state.loggedIsAdmin = true;
        }
      }
      state.fetched = true;
    });
    builder.addCase(fetchAutoAuthUser.rejected, (state, action) => {
      state.fetched = true;
    });
    builder.addCase(updateSelectedOrganization.fulfilled, (state, action) => {
      state.goPeopleCommunityId = action.payload.communityUuid;
      state.goPeopleOrganizationId = action.payload.organizationUuid;
    });
    builder.addCase(handleAuthSuccess.fulfilled, (state, { payload }) => {
      const { jwtToken, refreshToken, authC, user, transformed, selectedCommunity } = payload;
      state.jwtToken = jwtToken;
      state.refreshToken = refreshToken;
      state.token = authC.ttpAccessToken;
      state.expiresIn = authC.expiresAt;
      state.createdAt = Math.floor(Date.now() / 1000);
      state.scope = authC.scope;

      state.goPeopleUserId = user.uuid;
      state.goPeopleCommunityId = selectedCommunity?.uuid;

      state.user = user;
      // state.navCommunity = transformed.navCommunity;
      state.loggedAs = "COLLABORATOR";
    });
  },
});

export const {
  setAuth,
  setAuthUser,
  setAuthLoggedAs,
  setAuthLoggedAsPost,
  setAuthLoggedIsAdmin,
  setAuthToken,
  setClientToken,
  setExpiresIn,
  setTokenCreatedAt,
  setNavCommunity,
  setAuthTokenUser,
  setAuthJwtTokenUser,
  setAuthFetched,
  setAuthScope,
  unsetNavCommunity,
  setJwtToken,
  setRefreshToken,
  setAuthGoPeopleUserId,
  setAuthGoPeopleCommunityId,
  setAuthGoPeopleOrganizationId,
  setCommunitySwitchRequested,
  setCommunityOld,
  setAutoLoging
} = authSlice.actions;

export default authSlice.reducer;
